<ng-container *ngFor="let control of propertyControls">
  <ax-property-error
    *ngIf="control.touched"
    [form]="control"
    [label]="getLabel(control)"
  ></ax-property-error>
</ng-container>
